import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment, { ISO_8601 } from 'moment';
import { read, utils, writeFile } from 'xlsx';
import PublishIcon from '@material-ui/icons/Publish';
import {
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
  Grid,
  FormControlLabel,
  TextField,
  Backdrop,
  CircularProgress,
  MenuItem,
  Stack,
  Checkbox
} from '@material-ui/core';
import Controls from '../controls/Controls';
import { baseUrl, tempProvinces } from '../../utils/constants';
import { useSettingContext } from '../../context/setting_context';
import { useConstantsContext } from '../../context/constants_context';

const ProvinceSsbUpload = () => {
  const m = moment();
  const { subsAmount, assureAmount } = useSettingContext();
  const { payCycles } = useConstantsContext();
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [province, setProvince] = useState(1);
  const [cycleRefId, setCycleRefId] = useState(0);
  const [subAmount, setSubsAmount] = useState(subsAmount);
  const [addRevenue, setAddRevenue] = useState(false);
  const [monthDate, setMonthDate] = useState();
  const [insuranceAmount, setAssureAmount] = useState(assureAmount);
  const [exchangeRate, setExchangeRate] = useState(0);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [uploadedFile, setUploadedFile] = useState([]);
  const navigate = useNavigate();

  const currencies = [
    {
      value: 3,
      label: 'USD'
    },
    {
      value: 1,
      label: 'Zim Dollar'
    }
  ];

  const options = {
    raw: false,
    dateNF: 'yyyy-mm-dd' // Specify the date format string here
  };

  const handleImport = ($event) => {
    setLoading(true);
    const { files } = $event.target;
    if (files.length) {
      const file = files[0];

      setUploadedFile(file);
      const reader = new FileReader();
      reader.onload = (event) => {
        const wb = read(event.target.result, {
          type: 'binary',
          cellDates: true,
          cellNF: false,
          cellText: false
        });
        const sheets = wb.SheetNames;
        if (sheets.length) {
          const rows = utils.sheet_to_json(wb.Sheets[sheets[0]], options);
          // setRecords(rows);
          console.log('info:', rows);
          let newOptions = [];
          newOptions = rows.map((e) => ({
            ecNumber: e['E.C.N0'],
            firstName: e['FULL NAME'].substring(0, e['FULL NAME'].indexOf(' ')),
            surname: e['FULL NAME'].substring(e['FULL NAME'].indexOf(' ') + 1),
            idNumber: e['ID NUMBER'],
            cellNumber: e['PHONE NUMBER'],
            province: e.PROVINCE,
            schoolName: e['SCHOOL NAME'],
            dpt: e['DEPARTMENT CODE'],
            stn: e['STATION CODE'],
            description: e.DESCRIPTION,
            amount: 8, // e['AMOUNT IN US$'],
            ssbCode: '43690',
            groupId: province,
            deductionType: statusLookup(e.DESCRIPTION),
            source: e.PROVINCE
          }));
          console.log('newOptions:', newOptions);
          setRecords(newOptions);
          setLoading(false);
        } else {
          setLoading(false);
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const statusLookup = (param) => {
    switch (param) {
      case 'SUBS':
        return 'n';
      case 'CEASE':
        return 'd';
      default:
        return 'n';
    }
  };

  const uploadSsbChangeFiles = () => {
    if (province === 0 || cycleRefId === 0) {
      notifyPopup(`The Province or the Stroke is not selected!`, 'error');
      return;
    }

    if (uploadedFile.length === 0) {
      notifyPopup(`Please select file to upload!`, 'error');
      return;
    }
    setLoading(true);
    const jsonClient = [];
    const jsonData = {
      employerRefId: 1,
      ssbFileName: uploadedFile.name,
      upLoadDate: new Date(),
      upLoadedBy: sessionStorage.getItem('userRefId'),
      processState: 0,
      subsAmount: 0,
      insuranceAmount: 0,
      exchangeRate,
      fileType: 1,
      cycleRefId,
      addRevenue,
      province
    };
    jsonClient.push(jsonData);
    fetch(`${baseUrl}/api/ssb/saveSsbChangeFile`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          // uploadSsbChangeDetails(result.refId);
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in saving SSB Changes File!: ${error}`, 'error');
        }
      );
  };

  const SaveClientQuickFile = async (result) => {
    setLoading(true);
    const details = records.map((obj) => ({
      ...obj,
      groupId: province
    }));

    const jsonData = {
      details
    };

    const jsonClient = [];
    jsonClient.push(jsonData.details);
    console.log('payload: ', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/client/SaveClientQuickFile`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (res) => {
          console.log('returned new file', res);
          setLoading(false);
          navigate('/');
          notifyPopup(`New Clients File Uploaded Successfully!`, 'success');
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Uploading New Clients's File!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  return (
    <Card>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Typography variant="h4">Province SSB Upload</Typography>
      <CardContent>
        <Stack direction="row" alignItems="center" justifyContent="center" sx={{ mb: 2 }}>
          <Box component="span" sx={{ p: 1, border: '1px solid grey', borderRadius: 1 }}>
            <input
              type="file"
              name="file"
              className="custom-file-input"
              id="inputGroupFile"
              required
              onChange={handleImport}
              // accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          </Box>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={3}>
              <TextField
                id="cycleRefId"
                style={{ width: 180, height: 30, pb: 2 }}
                select
                size="small"
                value={cycleRefId}
                onChange={(e) => setCycleRefId(e.target.value)}
              >
                <MenuItem key="" value="0">
                  Select Stroke
                </MenuItem>
                {payCycles.map((item) => (
                  <MenuItem key={item.payCycleId} value={item.payCycleId}>
                    {moment(item.payDate).isValid()
                      ? moment(item.payDate).format('YYYY-MM-DD')
                      : ''}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                id="standard-select-currency"
                style={{ width: 180, height: 30, pb: 2 }}
                select
                size="small"
                value={province}
                onChange={(e) => setProvince(e.target.value)}
              >
                <MenuItem key="" value="1">
                  Select Province
                </MenuItem>
                {tempProvinces.map((option) => (
                  <MenuItem key={option.refId} value={option.refId}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>

          <Button
            type="button"
            variant="outlined"
            sx={{ minWidth: '180px', p: 1, px: 2, color: 'white', backgroundColor: '#000000' }}
            startIcon={<PublishIcon />}
            onClick={() => SaveClientQuickFile()}
          >
            Save File
          </Button>
        </Stack>

        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">ECNumber</TableCell>
                <TableCell align="left">First Name</TableCell>
                <TableCell align="left">Surname</TableCell>
                <TableCell align="left">ID #</TableCell>
                <TableCell align="left">Phone #</TableCell>
                <TableCell align="left">Province</TableCell>
                <TableCell align="left">Station</TableCell>
                <TableCell align="right">Dept</TableCell>
                <TableCell align="right">STN</TableCell>
                <TableCell align="right">Amount</TableCell>
                <TableCell align="right">SSB Code</TableCell>
                <TableCell align="right">Deduct Type</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {records.map((row) => (
                <TableRow>
                  <TableCell align="left">{row.ecNumber}</TableCell>
                  <TableCell align="left">{row.firstName}</TableCell>
                  <TableCell align="left">{row.surname}</TableCell>
                  <TableCell align="left">{row.idNumber}</TableCell>
                  <TableCell align="left">{row.cellNumber}</TableCell>
                  <TableCell align="left">{row.province}</TableCell>
                  <TableCell align="left">{row.schoolName}</TableCell>
                  <TableCell align="right">{row.dpt}</TableCell>
                  <TableCell align="right">{row.stn}</TableCell>
                  <TableCell align="right">{row.amount}</TableCell>
                  <TableCell align="right">{row.ssbCode}</TableCell>
                  <TableCell align="right">{row.deductionType}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Controls.Notification notify={notify} setNotify={setNotify} />
      </CardContent>
    </Card>
  );
};

export default ProvinceSsbUpload;
